module.exports = __webpack_public_path__ + "static/media/renewSplash.644fe99c.png";